import { render, staticRenderFns } from "./double_bottom.vue?vue&type=template&id=d765318e"
import script from "./double_bottom.vue?vue&type=script&lang=js"
export * from "./double_bottom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports